@import 'styles/variables';

table .cursorContainer {
  z-index: 1; // same as table borders, which is at 1 (see prose-core)
}

.cursorContainer {
  position: absolute;
  height: 100%;
  bottom: 0;

  border-left-style: solid;
  border-left-width: 1px;
  border-right-style: solid;
  border-right-width: 1px;
  border-bottom-left-radius: 1px;
  border-bottom-right-radius: 1px;

  .userName {
    position: absolute;
    left: -1px;
    font-size: 12px;
    font-weight: 400;
    font-family: 'Inter';
    font-style: normal;
    letter-spacing: 0;
    line-height: 17.4px;
    top: -17px;
    white-space: nowrap;
    padding: 0 2px;
    opacity: 0;

    background-clip: initial;
    -webkit-background-clip: initial;
    -moz-background-clip: initial;
    -webkit-text-fill-color: initial;
    -moz-text-fill-color: initial;
  }

  .cursorTop {
    position: absolute;
    left: -3px;
    top: -4px;
    border-radius: 2px;
    border-top-width: 8px;
    border-top-style: solid;
    border-right: 3px solid transparent;
    border-left: 3px solid transparent;
    opacity: 1;
  }

  .visible {
    opacity: 1;
    // can't use fadein mixin here, it's glitchy
    -webkit-transition: opacity 0.1s ease-in;
    -moz-transition: opacity 0.1s ease-in;
    -o-transition: opacity 0.1s ease-in;
    transition: opacity 0.1s ease-in;
  }

  .invisible {
    opacity: 0;
    // can't use hypothetical fadeout (as a reverse fadein) mixin here, it's glitchy
    -webkit-transition: opacity 0.1s ease-in;
    -moz-transition: opacity 0.1s ease-in;
    -o-transition: opacity 0.1s ease-in;
    transition: opacity 0.1s ease-in;
  }
}

// Green
.cursor-color-green {
  border-left-color: $cursor-green;
  border-right-color: $cursor-green;

  .userName {
    background-color: $cursor-green;
    color: $white;
  }

  .cursorTop {
    border-top-color: $cursor-green;
  }
}

.background-color-transparent-green {
  background-color: $cursor-transparent-green;
}

.border-color-green {
  border-color: $cursor-green;
}

.background-color-green-50 {
  background-color: $cursor-green-50;
}

// Blue
.cursor-color-blue {
  border-left-color: $cursor-blue;
  border-right-color: $cursor-blue;

  .userName {
    background-color: $cursor-blue;
    color: $white;
  }

  .cursorTop {
    border-top-color: $cursor-blue;
  }
}

.background-color-transparent-blue {
  background-color: $cursor-transparent-blue;
}

.border-color-blue {
  border-color: $cursor-blue;
}

.background-color-blue-50 {
  background-color: $cursor-blue-50;
}

// Purple
.cursor-color-purple {
  border-left-color: $cursor-purple;
  border-right-color: $cursor-purple;

  .userName {
    background-color: $cursor-purple;
    color: $white;
  }

  .cursorTop {
    border-top-color: $cursor-purple;
  }
}

.background-color-transparent-purple {
  background-color: $cursor-transparent-purple;
}

.border-color-purple {
  border-color: $cursor-purple;
}

.background-color-purple-50 {
  background-color: $cursor-purple-50;
}

// Orange
.cursor-color-orange {
  border-left-color: $cursor-orange;
  border-right-color: $cursor-orange;

  .userName {
    background-color: $cursor-orange;
    color: $white;
  }

  .cursorTop {
    border-top-color: $cursor-orange;
  }
}

.background-color-transparent-orange {
  background-color: $cursor-transparent-orange;
}

.border-color-orange {
  border-color: $cursor-orange;
}

.background-color-orange-50 {
  background-color: $cursor-orange-50;
}

// Red
.cursor-color-red {
  border-left-color: $cursor-red;
  border-right-color: $cursor-red;

  .userName {
    background-color: $cursor-red;
    color: $white;
  }

  .cursorTop {
    border-top-color: $cursor-red;
  }
}

.background-color-transparent-red {
  background-color: $cursor-transparent-red;
}

.border-color-red {
  border-color: $cursor-red;
}

.background-color-red-50 {
  background-color: $cursor-red-50;
}

// Pink
.cursor-color-pink {
  border-left-color: $cursor-pink;
  border-right-color: $cursor-pink;

  .userName {
    background-color: $cursor-pink;
    color: $white;
  }

  .cursorTop {
    border-top-color: $cursor-pink;
  }
}

.background-color-transparent-pink {
  background-color: $cursor-transparent-pink;
}

.border-color-pink {
  border-color: $cursor-pink;
}

.background-color-pink-50 {
  background-color: $cursor-pink-50;
}
